import Fetcher from '../common/Fetcher';
import PrestaGlobals from '../common/PrestaGlobals';

/**
 * Thin client for the `ucprefs` front controller (EA-485).
 * Saves a configurator parameter value scoped to the current context (shop + customer + cart), keyed
 * by the NAMED parameter — product-independent. The endpoint takes the shop/customer/cart ids from the
 * server context (guests supported: customer NULL + cart-scoped). Mirrors admin/AdminApi.tsx
 * (form-urlencoded POST via Fetcher).
 */
const base = (): string =>
    PrestaGlobals.virtualUri + '/index.php?fc=module&module=ubercabinet&controller=ucprefs';

const enc = (obj: Record<string, string | number>): string =>
    Object.entries(obj)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`)
        .join('&');

async function post<T = any>(action: string, body: Record<string, string | number>): Promise<T | null> {
    const f = new Fetcher<T>(`${base()}&action=${action}`, 'POST');
    await f.request(enc(body));
    return f.Result;
}

const PrefsApi = {
    /** Save a parameter value scoped to the current shop/customer/cart. `id` is uc_style_product_parameters.id. */
    savePref: (id: string, value: string) =>
        post<{ success: boolean; style_parameter_id: number } | { error: string }>(
            'savePref', { id, value },
        ),
};

export default PrefsApi;
